export const regexExpressions = {
  password: {
    atLeast8Characters: /.{8,}/,
    oneLowercaseLetter: /[a-z]/,
    oneUppercaseLetter: /[A-Z]/,
    oneNumber: /\d/,
    oneSpecialCharacter: /[@$!%*?&]/,
  },
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // NOSONAR - anchored email pattern, practical inputs are bounded
  phoneNumber: /^\d{10}$/, // NOSONAR - anchored fixed-length pattern, no backtracking risk
  numbers: /[^0-9]/g // NOSONAR - simple character class negation, no quantifiers
};